import script from "./BuyTraitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyTraitModal.vue?vue&type=script&setup=true&lang=js"

import "./BuyTraitModal.vue?vue&type=style&index=0&id=66c3fbe0&lang=scss"

const __exports__ = script;

export default __exports__